import { Button, Checkbox, Col, Row, Form, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import InputBox from "../../../../components/common/input";
import DropdownSelect from "../../../../components/common/select";
import CommonDatePicker from "../../../../components/common/datepicker";
import CommonUpload from "../../../../components/common/upload-image";
import FileUpload from "../../../../components/common/upload-file/FileUpload";
import { useDispatch, useSelector } from "react-redux";
import { listCelebrityCategory } from "../../../../redux/reducer/CelebrityCategorySlice";
import { listHomeCategory } from "../../../../redux/reducer/homeCategorySlice";
import { listSubscriptionFun } from "../../../../redux/reducer/SubscriptionSlice";
import { listPodcastCategory } from "../../../../redux/reducer/PodcastCategorySlice";
import FileUploadFun from "../../../../components/common/fileUploadFun/FileUploadFun";
import { uploadFile } from "../../../../redux/reducer/UploadSlice";
import AudioUpload from "../../../../components/common/audio-upload/AudioUpload";
import {
  addPodcast,
  updatePodcast,
  viewPodcast,
} from "../../../../redux/reducer/ManagePodcastSlice";
import { toast } from "react-toastify";
import { Spin } from "antd";
import FileUploadTwo from "../../../../components/common/fileUploadFun/FileUploadTwo";
import { listAuthors } from "../../../../redux/reducer/authorSlice";
const options = [
  { label: "Option 1", value: "1" },
  { label: "Option 2", value: "2" },
  { label: "Option 3", value: "3" },
];
const AddPodcast = () => {
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const location = useLocation();
  const [uploadedFile, setUploadedFile] = useState(null);
  const { fileUrl } = useSelector((state) => state.upload);
  const [audioFilesLinks, setAudioFileLinks] = useState({
    file_url_en: "",
    file_url_es: "",
    file_url_pt: "",
  });
  const [imageFilesLinks, setImageFileLinks] = useState({
    book_cover_en: "",
    book_cover_es: "",
    book_cover_pt: "",
  });
  const [previewImages, setPreviewImages] = useState(() => ({
    book_cover_en: null,
    book_cover_es: null,
    book_cover_pt: null,
    thumbnail_en: null,
    thumbnail_es: null,
    thumbnail_pt: null,
  }));

  const [audioDuration, setAudioDuration] = useState({
    duration_en: 0,
    duration_es: 0,
    duration_pt: 0,
  });

  const editData = location?.state?.editData || null;

  const { viewPodcastData } = useSelector((prev) => prev?.managePodcast);

  // useEffect(() => {
  //   if (audioFilesLinks.file_url_en === "") {
  //     form.setFields([
  //       {
  //         name: "file_url_en",
  //         errors: ["Please upload an audio file (en)"],
  //       },
  //     ]);
  //   } else {
  //     form.setFields([
  //       {
  //         name: "file_url_en",
  //         errors: [],
  //       },
  //     ]);
  //   }
  // }, [audioFilesLinks.file_url_en]);

  // useEffect(() => {
  //   if (audioFilesLinks.file_url_es === "") {
  //     form.setFields([
  //       {
  //         name: "file_url_es",
  //         errors: ["Please upload an audio file (es)"],
  //       },
  //     ]);
  //   } else {
  //     form.setFields([
  //       {
  //         name: "file_url_es",
  //         errors: [],
  //       },
  //     ]);
  //   }
  // }, [audioFilesLinks.file_url_es]);

  // useEffect(() => {
  //   if (audioFilesLinks.file_url_pt === "") {
  //     form.setFields([
  //       {
  //         name: "file_url_pt",
  //         errors: ["Please upload an audio file (pt)"],
  //       },
  //     ]);
  //   } else {
  //     form.setFields([
  //       {
  //         name: "file_url_pt",
  //         errors: [],
  //       },
  //     ]);
  //   }
  // }, [audioFilesLinks.file_url_pt]);

  useEffect(() => {
    if (viewPodcastData && editData) {
      form.setFieldsValue({
        title_en: viewPodcastData.title_en,
        title_es: viewPodcastData.title_es,
        title_pt: viewPodcastData.title_pt,
        short_desc_en: viewPodcastData.short_desc_en,
        short_desc_es: viewPodcastData.short_desc_es,
        short_desc_pt: viewPodcastData.short_desc_pt,
        desc_en: viewPodcastData.desc_en,
        desc_es: viewPodcastData.desc_es,
        desc_pt: viewPodcastData.desc_pt,
        intended_audience_en: viewPodcastData.intended_audience_en,
        intended_audience_es: viewPodcastData.intended_audience_es,
        intended_audience_pt: viewPodcastData.intended_audience_pt,
        author_name_en: viewPodcastData.author_name_en,
        author_name_es: viewPodcastData.author_name_es,
        author_name_pt: viewPodcastData.author_name_pt,
        author_id: viewPodcastData.author_id,
        // duration: viewPodcastData.duration,
        sequence: viewPodcastData.sequence,
        p_category_ids: viewPodcastData?.PodcastCategories?.map(
          (data) => data?.id
        ),
        h_category_ids: viewPodcastData?.HomeCategoryTags?.map(
          (data) => data?.id
        ),
        subscription_ids: viewPodcastData?.SubscriptionPlans?.map(
          (data) => data?.id
        ),
        celebrity_ids: viewPodcastData?.CelebrityMasters?.map(
          (data) => data?.id
        ),
        status: viewPodcastData.status,
        book_cover_en: viewPodcastData.book_cover_en || null,
        book_cover_es: viewPodcastData.book_cover_es || null,
        book_cover_pt: viewPodcastData.book_cover_pt || null,
        thumbnail_en: viewPodcastData.thumbnail_en || null,
        thumbnail_es: viewPodcastData.thumbnail_es || null,
        thumbnail_pt: viewPodcastData.thumbnail_pt || null,
      });
      // setAudioFileLinks({
      //   file_url_en: viewPodcastData.file_url_en || "",
      //   file_url_es: viewPodcastData.file_url_es || "",
      //   file_url_pt: viewPodcastData.file_url_pt || "",
      // });

      setAudioDuration({
        duration_en: viewPodcastData.duration_en
          ? `${viewPodcastData.duration_en}`
          : null,
        duration_es: viewPodcastData.duration_es
          ? `${viewPodcastData.duration_es}`
          : null,
        duration_pt: viewPodcastData.duration_pt
          ? `${viewPodcastData.duration_pt}`
          : null,
      });

      setAudioFileLinks({
        file_url_en: viewPodcastData.file_url_en
          ? `${viewPodcastData.file_url_en}`
          : null,
        file_url_es: viewPodcastData.file_url_es
          ? `${viewPodcastData.file_url_es}`
          : null,
        file_url_pt: viewPodcastData.file_url_pt
          ? `${viewPodcastData.file_url_pt}`
          : null,
      });

      setPreviewImages({
        book_cover_en: viewPodcastData.book_cover_en
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.book_cover_en}`
          : null,
        book_cover_es: viewPodcastData.book_cover_es
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.book_cover_es}`
          : null,
        book_cover_pt: viewPodcastData.book_cover_pt
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.book_cover_pt}`
          : null,
        thumbnail_en: viewPodcastData.thumbnail_en
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.thumbnail_en}`
          : null,
        thumbnail_es: viewPodcastData.thumbnail_es
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.thumbnail_es}`
          : null,
        thumbnail_pt: viewPodcastData.thumbnail_pt
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.thumbnail_pt}`
          : null,
      });
    } else {
      form.resetFields(); // Ensure blank form on add
    }
  }, [editData, viewPodcastData, form]);

  useEffect(() => {
    if (editData) {
      dispatch(viewPodcast(editData?.id));
    }
  }, [dispatch, editData]);

  const audioUploadEn = async (file) => {
    const data = await dispatch(uploadFile(file));
    setAudioFileLinks((prev) => ({
      ...prev,
      file_url_en: data?.payload?.result?.rows?.[0]?.image_url,
    }));
  };
  const audioUploadEs = async (file) => {
    const data = await dispatch(uploadFile(file));
    setAudioFileLinks((prev) => ({
      ...prev,
      file_url_es: data?.payload?.result?.rows?.[0]?.image_url,
    }));
  };
  const audioUploadPt = async (file) => {
    const data = await dispatch(uploadFile(file));
    setAudioFileLinks((prev) => ({
      ...prev,
      file_url_pt: data?.payload?.result?.rows?.[0]?.image_url,
    }));
  };

  useEffect(() => {
    dispatch(listHomeCategory({ size: 100 }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(listCelebrityCategory({ size: 200 }));
    dispatch(listAuthors({ size: 5000 }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(listSubscriptionFun());
  }, [dispatch]);

  useEffect(() => {
    dispatch(listPodcastCategory({ size: 200 }));
  }, [dispatch]);

  const { listPodcastCategorydata, listPodcastCategoryLoading } = useSelector(
    (prev) => prev?.podcastCategory
  );
  const { listCategory: celebrityCategoryData } = useSelector(
    (prev) => prev?.celebrityCategory
  );
  const { listCategory: homeCategoryData } = useSelector(
    (prev) => prev?.homeCategory
  );
  const { listAuthorData, listAuthorLoading } = useSelector(
    (state) => state?.author
  );
  const { listSubscription } = useSelector((state) => state?.subscription);

  const ModifiedSubscriptionData = listSubscription.map(({ id, name_en }) => ({
    label: name_en,
    value: id,
  }));
  const ModifiedHomeCategorynData = homeCategoryData.map(({ id, name_en }) => ({
    label: name_en,
    value: id,
  }));
  const ModifiedCelebrityData = celebrityCategoryData.map(
    ({ id, name_en }) => ({ label: name_en, value: id })
  );
  const ModifiedPodcastData = listPodcastCategorydata?.map(
    ({ id, name_en }) => ({ label: name_en, value: id })
  );
  // const ModifiedAuthorData = listAuthorData?.map(({ id, name }) => ({
  //   label: name,
  //   value: id,
  // }));

  const ModifiedAuthorData = [
    { label: "Not Select" },
    ...(listAuthorData?.map(({ id, name }) => ({
      label: name,
      value: id,
    })) ?? []),
  ];

  const handleUploadSuccess = (field, url) => {
    form.setFieldsValue({ [field]: url });
  };

  const handleChange = async (value) => {
    const payload = {
      title_en: value?.title_en,
      title_es: value?.title_es,
      title_pt: value?.title_pt,
      author_id: value?.author_id,
      author_name_en: value?.author_name_en,
      author_name_es: value?.author_name_es,
      author_name_pt: value?.author_name_pt,
      // duration: value?.duration,
      p_category_ids: value?.p_category_ids,
      h_category_ids: value?.h_category_ids,
      subscription_ids: value?.subscription_ids,
      celebrity_ids: value?.celebrity_ids,
      short_desc_en: value?.short_desc_en,
      short_desc_es: value?.short_desc_es,
      short_desc_pt: value?.short_desc_pt,
      desc_en: value?.desc_en,
      desc_es: value?.desc_es,
      sequence: 1,
      desc_pt: value?.desc_pt,
      book_cover_en: value?.book_cover_en,
      book_cover_es: value?.book_cover_es,
      book_cover_pt: value?.book_cover_pt,
      thumbnail_en: value?.thumbnail_en,
      thumbnail_es: value?.thumbnail_es,
      thumbnail_pt: value?.thumbnail_pt,
      intended_audience_en: value.intended_audience_en,
      intended_audience_es: value.intended_audience_es,
      intended_audience_pt: value.intended_audience_pt,
      // file_url_en: value?.file_url_en,
      // file_url_es: value?.file_url_es,
      // file_url_pt: value?.file_url_pt,
      ...audioFilesLinks,
      ...audioDuration,
      // ...audioFilesLinks,
    };

    let response;

    if (editData) {
      response = await dispatch(
        updatePodcast({ id: viewPodcastData?.id, data: payload })
      );

      if (response.type === "data/update/podcast/fulfilled") {
        toast.success("Podcast updated successfully");
        navigate(-1);
      }
      if (response.type === "data/update/podcast/rejected") {
        toast.error(response?.payload?.message);
      }
    } else {
      response = await dispatch(addPodcast(payload));

      if (response.payload.code === 201) {
        toast.success(response?.payload?.message);
        navigate("/manage-podcast");
      } else {
        toast.error(response?.payload?.message);
      }
    }

    setSelectedValue(value);
  };
  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">
          {editData ? "Edit" : "Add"} Podcast Details
        </div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            {editData ? "Update" : "Save"} Details
          </Button>
        </Space>
      </div>
      <Form form={form} layout="vertical" onFinish={handleChange}>
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item
              name="title_en"
              label="Title (en)"
              // rules={[{ required: true, message: "Enter Title name (en)" }]}
            >
              <InputBox
                size="large"
                placeholder="Enter podcast title"
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="title_es"
              label="Title (es)"
              // rules={[{ required: true, message: "Enter Title name (es)" }]}
            >
              <InputBox
                size="large"
                placeholder="Enter podcast title"
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="title_pt"
              label="Title (pt)"
              // rules={[{ required: true, message: "Enter Title name (pt)" }]}
            >
              <InputBox
                size="large"
                placeholder="Enter podcast title"
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="author_id"
              label="Author Name"
              // rules={[{ required: true, message: "Select Author" }]}
            >
              {!listAuthorLoading && listAuthorData?.length > 0 ? (
                <DropdownSelect
                  options={ModifiedAuthorData}
                  placeholder="Choose..."
                  // mode="multiple"
                  value={form.getFieldValue("author_id")}
                  onChange={(value) =>
                    form.setFieldsValue({ author_id: value })
                  }
                />
              ) : (
                <Spin tip="Processing..." />
              )}
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="p_category_ids"
              label="Podcast Category"
              rules={[{ required: true, message: "Select Category" }]}
            >
              {!listPodcastCategoryLoading &&
              listPodcastCategorydata?.length > 0 ? (
                <DropdownSelect
                  options={ModifiedPodcastData}
                  placeholder="Choose..."
                  mode="multiple"
                  value={form.getFieldValue("p_category_ids")}
                  onChange={(value) =>
                    form.setFieldsValue({ p_category_ids: value })
                  }
                />
              ) : (
                <Spin tip="Processing..." />
              )}
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="h_category_ids" label="Home Category(Optional)">
              <DropdownSelect
                options={ModifiedHomeCategorynData}
                placeholder="Choose..."
                mode="multiple"
                value={form.getFieldValue("h_category_ids")}
                onChange={(value) =>
                  form.setFieldsValue({ h_category_ids: value })
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="subscription_ids"
              label="Add To Plan"
              rules={[{ required: true, message: "Select Plan" }]}
            >
              <DropdownSelect
                options={ModifiedSubscriptionData}
                placeholder="Choose..."
                mode="multiple"
                value={form.getFieldValue("subscription_ids")}
                onChange={(value) =>
                  form.setFieldsValue({ subscription_ids: value })
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="celebrity_ids"
              label="Picked By Celebrity (Optional)"
            >
              <DropdownSelect
                options={ModifiedCelebrityData}
                placeholder="Choose..."
                mode="multiple"
                value={form.getFieldValue("celebrity_ids")}
                onChange={(value) =>
                  form.setFieldsValue({ celebrity_ids: value })
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}></Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="intended_audience_en"
              label="Intended audience (en)"
              // rules={[
              //   {
              //     required: true,
              //     message: "Enter Intended audience name (en)",
              //   },
              // ]}
            >
              <InputBox
                size="large"
                placeholder="Enter Intended audience name (en)"
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="intended_audience_es"
              label="Intended audience (es)"
              // rules={[
              //   {
              //     required: true,
              //     message: "Enter Intended audience name (es)",
              //   },
              // ]}
            >
              <InputBox
                size="large"
                placeholder="Enter Intended audience name (es)"
                className="custom-input"
              />
            </Form.Item>
          </Col>{" "}
          <Col xs={24} sm={8}>
            <Form.Item
              name="intended_audience_pt"
              label="Intended audience (pt)"
              // rules={[
              //   {
              //     required: true,
              //     message: "Enter Intended audience name (pt)",
              //   },
              // ]}
            >
              <InputBox
                size="large"
                placeholder="Enter Intended audience name (pt)"
                className="custom-input"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="short_desc_en"
              label="Short Description (Max 200 Words) (en)"
              // rules={[{ required: true, message: "Enter Short Description  (en)" }]}
            >
              <InputBox
                size="large"
                placeholder="Enter short description in 200 words"
                className="custom-input"
                // label="Short Description (Max 200 Words) (en)"
                isMultiline
                rows={4}
                style={{ height: "70px" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="short_desc_es"
              label="Short Description (Max 200 Words) (es)"
              // rules={[{ required: true, message: "Enter Short Description  (es)" }]}
            >
              <InputBox
                size="large"
                placeholder="Enter short description in 200 words"
                className="custom-input"
                // label="Short Description (Max 200 Words) (es)"
                isMultiline
                rows={4}
                style={{ height: "70px" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="short_desc_pt"
              label="Short Description (Max 200 Words) (pt)"
              // rules={[{ required: true, message: "Enter Short Description  (pt)" }]}
            >
              <InputBox
                size="large"
                placeholder="Enter short description in 200 words"
                className="custom-input"
                // label="Short Description (Max 200 Words) (pt)"
                isMultiline
                rows={4}
                style={{ height: "70px" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="desc_en"
              label="Long Description (Max 500 Words) (en)"
              // rules={[{ required: true, message: "Long Description (en)" }]}
            >
              <InputBox
                // label="Long Description (Max 500 Words) (en)"
                placeholder="Enter long description in 500 words"
                className="custom-input"
                isMultiline
                rows={4}
                style={{ height: "100px" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="desc_es"
              label="Long Description (Max 500 Words) (es)"
              // rules={[{ required: true, message: "Long Description (es)" }]}
            >
              <InputBox
                // label="Long Description (Max 500 Words) (es)"
                placeholder="Enter long description in 500 words"
                className="custom-input"
                isMultiline
                rows={4}
                style={{ height: "100px" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="desc_pt"
              label="Long Description (Max 500 Words) (pt)"
              // rules={[{ required: true, message: "Long Description (pt)" }]}
            >
              <InputBox
                // label="Long Description (Max 500 Words) (pt)"
                placeholder="Enter long description in 500 words"
                className="custom-input"
                isMultiline
                rows={4}
                style={{ height: "100px" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="file_url_en"
              label="Upload audio (en)"
              // rules={[
              //   {
              //     required: true,
              //     validator: async () => {
              //       if (!audioFilesLinks.file_url_en) {
              //         return Promise.reject(
              //           new Error("Please upload an audio file (en)")
              //         );
              //       }
              //     },
              //   },
              // ]}
            >
              <AudioUpload
                onDurationExtracted={(dur) =>
                  setAudioDuration((prev) => ({
                    ...prev,
                    duration_en: Math.floor(dur),
                  }))
                }
                onFileUpload={audioUploadEn}
                audioSrc={
                  editData
                    ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.file_url_en}`
                    : ""
                }
              />
            </Form.Item>
          </Col>{" "}
          <Col xs={24} sm={8}>
            <Form.Item
              name="file_url_es"
              label="Upload audio (es)"
              // rules={[
              //   {
              //     required: true,
              //     validator: async () => {
              //       if (!audioFilesLinks.file_url_es) {
              //         return Promise.reject(
              //           new Error("Please upload an audio file (es)")
              //         );
              //       }
              //     },
              //   },
              // ]}
            >
              <AudioUpload
                onDurationExtracted={(dur) =>
                  setAudioDuration((prev) => ({
                    ...prev,
                    duration_es: Math.floor(dur),
                  }))
                }
                onFileUpload={audioUploadEs}
                audioSrc={
                  editData
                    ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.file_url_es}`
                    : ""
                }
              />
            </Form.Item>
          </Col>{" "}
          <Col xs={24} sm={8}>
            <Form.Item
              name="file_url_pt"
              label="Upload audio (pt)"
              // rules={[
              //   {
              //     required: true,
              //     validator: async () => {
              //       if (!audioFilesLinks.file_url_pt) {
              //         return Promise.reject(
              //           new Error("Please upload an audio file (pt)")
              //         );
              //       }
              //       return Promise.resolve();
              //     },
              //   },
              // ]}
            >
              <AudioUpload
                onDurationExtracted={(dur) =>
                  setAudioDuration((prev) => ({
                    ...prev,
                    duration_pt: Math.floor(dur),
                  }))
                }
                onFileUpload={audioUploadPt}
                audioSrc={
                  editData
                    ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.file_url_pt}`
                    : ""
                }
              />
            </Form.Item>
          </Col>{" "}
          <Col xs={24} sm={8}>
            <Form.Item
              name="book_cover_en"
              label="Upload Cover Image (en)"
              // rules={[
              //   { required: true, message: "Please upload a Cover Image" },
              // ]}
            >
              <FileUploadTwo
                label2={"Upload File"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) =>
                  handleUploadSuccess("book_cover_en", url)
                }
                initialPreview={previewImages.book_cover_en}
                // initialPreview={`${process.env.REACT_APP_API_IMG_URI}/${previewImages.book_cover_en}`}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="book_cover_es"
              label="Upload Cover Image (es)"
              // rules={[
              //   { required: true, message: "Please upload a Cover Image" },
              // ]}
            >
              <FileUploadTwo
                label2={"Upload File"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) =>
                  handleUploadSuccess("book_cover_es", url)
                }
                initialPreview={previewImages.book_cover_es}
              />
            </Form.Item>
          </Col>{" "}
          <Col xs={24} sm={8}>
            <Form.Item
              name="book_cover_pt"
              label="Upload Cover Image (pt)"
              // rules={[
              //   { required: true, message: "Please upload a Cover Image" },
              // ]}
            >
              <FileUploadTwo
                label2={"Upload File"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) =>
                  handleUploadSuccess("book_cover_pt", url)
                }
                initialPreview={previewImages.book_cover_pt}
              />
            </Form.Item>
          </Col>
          {/* upload Thumbnail */}
          <Col xs={24} sm={8}>
            <Form.Item
              name="thumbnail_en"
              label="Upload Thumbnail Image (en)"
              // rules={[
              //   { required: true, message: "Please upload a Thumbnail Image" },
              // ]}
            >
              <FileUploadTwo
                label2={"Upload File"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) =>
                  handleUploadSuccess("thumbnail_en", url)
                }
                initialPreview={previewImages.thumbnail_en}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="thumbnail_es"
              label="Upload Thumbnail Image (es)"
              // rules={[
              //   { required: true, message: "Please upload a Thumbnail Image" },
              // ]}
            >
              <FileUploadTwo
                label2={"Upload File"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) =>
                  handleUploadSuccess("thumbnail_es", url)
                }
                initialPreview={previewImages.thumbnail_es}
              />
            </Form.Item>
          </Col>{" "}
          <Col xs={24} sm={8}>
            <Form.Item
              name="thumbnail_pt"
              label="Upload Thumbnail Image (pt)"
              // rules={[
              //   { required: true, message: "Please upload a Thumbnail Image" },
              // ]}
            >
              <FileUploadTwo
                label2={"Upload File"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) =>
                  handleUploadSuccess("thumbnail_pt", url)
                }
                initialPreview={previewImages.thumbnail_pt}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AddPodcast;
